import { Routes } from "@angular/router";

export const APP_ROUTES: Routes = [
    {
        path: "",
        redirectTo: "app",
        pathMatch: "full",
    },
    {
        path: "app",
        loadChildren: () =>
            import("./app-wrapper/shell.routes").then((m) => m.SHELL_ROUTES),
    },
    {
        path: "",
        loadChildren: () =>
            import("./auth/auth.routes").then((m) => m.AUTH_ROUTES),
    },
    {
        path: "**",
        loadComponent: () =>
            import("./auth/containers/not-found-container/page-not-found-container.component").then(
                (m) => m.PageNotFoundContainerComponent,
            ),
    },
];
